import { render, staticRenderFns } from "./DocumentationModal.vue?vue&type=template&id=a1412330"
import script from "./DocumentationModal.vue?vue&type=script&lang=js"
export * from "./DocumentationModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentationModal.vue?vue&type=style&index=0&id=a1412330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports